import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import Sidebar from "../common/sidebar";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import DataTable from "react-data-table-component";
import CommonAlert from "../common/Commonalert";
import ShowAlert from "../common/Showalert";
import { useTranslation } from "react-i18next";
import AlertPopup from "../common/alertPopup";
import { dateformatwithuktime } from "../utilityfunctions";
const EmailCampaign = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [templist, setTempList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [campaignValue, setCampaignValue] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertErrorPopup, setAlertErrorPopup] = useState(false);
  const [alertErrorMessage, setAlertErrorMessage] = useState("");
  const [searchTextVal, setSearchTextVal] = useState("");
  const [showRunStatusPopup, setShowRunStatusPopup] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const emailTypeMap = {
    logged_in_not_order: t("logged_in_ordered_email_txt"),
    logged_in_not_order_cutoff: t("logged_in_ordered_email_cutoff_txt"),
    abandoned_cart: t("abandoned_cart_email_txt"),
  };
  const tabs = [
    { name: t("all_txt"), value: "all" },
    { name: t("running_txt"), value: "run" },
    { name: t("paused_txt"), value: "pause" },
    { name: t("completed_txt"), value: "completed" },
    { name: t("draft_txt"), value: "draft" },
  ];

  const [activeTab, setActiveTab] = useState("all");

  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData")
    ).adminRole.permissions.includes("manage_emailcampaign")
  ) {
    window.location.href = "/unauthorized";
  }

  useEffect(() => {
    fetchCampaigns();
  }, []);

  useEffect(() => {
    filterData();
  }, [searchTextVal, activeTab]);

  const fetchCampaigns = async () => {
    setIsLoading(true);
    try {
      const URL = BaseUrl + `admin/getEmailCampaigns`;
      const response = await http.get(URL);
      if (response.data.success === true) {
        setData(response.data.data);
        setTempList(response.data.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddCampaign = () => {
    navigate("/email-campaign/add");
  };

  const handleShowEditCampaign = (value, isViewOnly = false) => {
    navigate("/email-campaign/edit", {
      state: { campaignData: value, viewOnly: isViewOnly },
    });
  };

  const showDeletePopup = (value) => {
    setVisibleAlert(true);
    setCampaignValue(value);
  };

  const deleteCampaign = async () => {
    setVisibleAlert(false);
    setIsActionLoading(true);
    try {
      const URL = BaseUrl + `admin/deleteEmailCampaign/${campaignValue._id}`;
      const response = await http.delete(URL);
      if (response.data.success) {
        setAlertMessage(t("campaign_delete_success_msg"));
        setAlertPopup(true);
        fetchCampaigns();
      } else {
        setAlertErrorMessage(t("campaign_delete_fail_msg"));
        setAlertErrorPopup(true);
      }
    } catch (err) {
      setAlertErrorMessage(t("campaign_delete_error_msg"));
      setAlertErrorPopup(true);
    } finally {
      setIsActionLoading(false);
      setCampaignValue({});
    }
  };

  const handleConfirmRunStatusChange = async () => {
    if (!selectedCampaign) return;
    setShowRunStatusPopup(false);
    setIsActionLoading(true);
    try {
      const newStatus = selectedCampaign.runStatus === "run" ? "pause" : "run";
      const URL = BaseUrl + `admin/updateCampaignStatus`;
      const payload = {
        campaignId: selectedCampaign._id,
        runStatus: newStatus,
      };
      const response = await http.put(URL, payload);
      if (response.data.success) {
        const statusText =
          newStatus === "run" ? t("run_started_txt") : t("run_paused_txt");
        setAlertMessage(
          t("campaign_status_change_msg", {
            campaignName: selectedCampaign.emailCampaignName,
            status: statusText,
          })
        );
        setAlertPopup(true);
        fetchCampaigns();
      } else {
        setAlertErrorMessage(t("campaign_status_update_failed_msg"));
        setAlertErrorPopup(true);
      }
    } catch (err) {
      console.error(err);
      setAlertErrorMessage(t("campaign_status_update_error_msg"));
      setAlertErrorPopup(true);
    } finally {
      setIsActionLoading(false);
      setSelectedCampaign(null);
    }
  };

  const alertPopupclose = () => {
    setVisibleAlert(false);
    setCampaignValue({});
  };

  const handleReset = () => {
    setSearchTextVal("");
    setData(templist);
  };

  const normalize = (str = "") => str.toLowerCase().replace(/[\s\-_]+/g, "");

  const filterData = async () => {
    let currentFilterData = templist;
    
    if (["run", "draft", "completed", "pause"].includes(activeTab)) {
      console.log(activeTab, "activeTab");
      if (activeTab === "run") {
        currentFilterData = currentFilterData.filter(
          (item) => item.runStatus === "run"
        );
      } else if (activeTab === "draft") {
        currentFilterData = currentFilterData.filter(
          (item) => item.status === "draft" && item.runStatus === "pause"
        );
      } else if (activeTab === "pause") {
        currentFilterData = currentFilterData.filter(
          (item) => item.runStatus === "pause" && item.status === "scheduled"
        );
      } else if (activeTab === "completed") {
        currentFilterData = currentFilterData.filter(
          (item) => item.runStatus === "stop"
        );
      }
    }
    const input = (searchTextVal ?? "").toString().trim();
    if (input.length > 0) {
      const searchKey = normalize(input);
      currentFilterData = currentFilterData.filter((item) => {
        const templateNameMatch = normalize(
          item?.emailCampaignName || ""
        ).includes(searchKey);
        const emailTypeMatch = normalize(
          emailTypeMap[item?.emailType] || item?.emailType || ""
        ).includes(searchKey);
        return templateNameMatch || emailTypeMatch;
      });
    }
    setData(currentFilterData);
  };

  const columns = [
    {
      name: t("campaign_name_txt"),
      selector: (row) => row?.emailCampaignName,
      sortable: true,
    },
    {
      name: t("email_type_txt"),
      selector: (row) => emailTypeMap[row?.emailType] || row?.emailType,
      sortable: true,
    },
    {
      name: t("cutoff_time_txt"),
      selector: (row) => row?.cutoffTime,
      sortable: true,
    },
    {
      name: t("campaign_mode_txt"),
      selector: (row) => (row?.autoEmail ? t("auto_txt") : t("manual_txt")),
      sortable: true,
    },
    {
      name: t("status_txt"),
      selector: (row) => {
        if (!row?.status) return "";
        if (
          row.status.toLowerCase() === "scheduled" &&
          row.runStatus.toLowerCase() === "run"
        )
          return t("running_txt");
        if (
          row.status.toLowerCase() === "scheduled" &&
          row.runStatus.toLowerCase() == "pause"
        )
          return t("paused_txt");
        if (
          row.status.toLowerCase() === "scheduled" &&
          row.runStatus.toLowerCase() == "stop"
        )
          return t("completed_txt");
        return (
          row.status.charAt(0).toUpperCase() + row.status.slice(1).toLowerCase()
        );
      },
      sortable: true,
    },
    {
      name: t("scheduled_date_txt"),
      selector: (row) =>
        row.scheduledSendTime
          ? dateformatwithuktime(row.scheduledSendTime)
          : "-",
      sortable: true,
    },
    {
      name: t("actions_txt"),
      selector: (row) => (
        <div style={{ display: "flex" }}>
          <a
            className="button title-tooltip title-up"
            data-title={
              ["run", "stop"].includes(row.runStatus)
                ? t("view_txt")
                : t("edit_txt")
            }
            style={{ color: "white" }}
            onClick={() =>
              handleShowEditCampaign(
                row,
                ["run", "stop"].includes(row.runStatus) ? true : false
              )
            }
          >
            <i
              className={`fa ${
                ["run", "stop"].includes(row.runStatus) ? "fa-eye" : "fa-pencil"
              }`}
              aria-hidden="true"
            ></i>
          </a>
          {row.status?.toLowerCase() === "draft" && (
            <a
              className="button title-tooltip title-up"
              data-title={t("delete_txt")}
              style={{ color: "white" }}
              onClick={() => showDeletePopup(row)}
            >
              <i className="fa fa-trash" aria-hidden="true"></i>
            </a>
          )}
          {row.status?.toLowerCase() === "scheduled" &&
            row.runStatus != "stop" && (
              <a
                className="button title-tooltip title-up"
                data-title={
                  row.runStatus === "pause" ? t("start_txt") : t("pause_txt")
                }
                style={{ color: "white" }}
                onClick={() => {
                  setAlertPopup(false);
                  setAlertMessage("");
                  setSelectedCampaign(row);
                  setShowRunStatusPopup(true);
                }}
              >
                <i
                  className={`fa ${
                    row.runStatus === "pause" ? "fa-play" : "fa-pause"
                  }`}
                  aria-hidden="true"
                ></i>
              </a>
            )}
        </div>
      ),
    },
  ];

  const customStyles = {
    rows: {
      style: { minHeight: "25px" },
    },
    headCells: {
      style: { padding: "8px" },
    },
    cells: {
      style: { padding: "8px" },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  return (
    <section className="dashboard-block">
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          {alertPopup && (
            <AlertPopup
              title={t("alert_txt")}
              message={alertMessage}
              handleOk={() => setAlertPopup(false)}
            />
          )}
          {alertErrorPopup && (
            <AlertPopup
              title={t("alert_txt")}
              message={alertErrorMessage}
              handleOk={() => setAlertErrorPopup(false)}
            />
          )}
          <div className="container">
            <div className="flex-title">
              <h1 className="checkout-title">
                {t("email_campaign_management_title")}
              </h1>
            </div>
            <div className="right-table-outer-wrap">
              <div className="table-filter search-orders">
                <div className="table-search-reset">
                  <div className="table-search">
                    <input
                      type="text"
                      value={searchTextVal}
                      onChange={(e) => setSearchTextVal(e.target.value)}
                      className="form-control"
                      placeholder={t("campaign_search_placeholder_txt")}
                    />
                  </div>
                  <button
                    className="submitbtn button search-ord-btn"
                    onClick={filterData}
                  >
                    <i className="fa fa-search"></i>
                  </button>
                  <button
                    className="resetbtn"
                    type="reset"
                    onClick={() => handleReset()}
                  >
                    {t("reset_txt")}
                  </button>
                </div>
                <div>
                  <button onClick={() => handleAddCampaign()}>
                    {t("add_txt")}
                  </button>
                </div>
              </div>
              <div className="right-table-outer-wrap">
                <div className="flex-container">
                  <div className="header-tab-menu">
                    {tabs.map((tab) => (
                      <a
                        key={tab.name}
                        className={activeTab === tab.value ? "active" : ""}
                        onClick={() => setActiveTab(tab.value)}
                      >
                        {tab.name}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
              {!isLoading && data.length > 0 && (
                <div className="admin-order account-total-records">
                  <br />
                  {t("total_record_txt")}
                  {data.length}
                </div>
              )}
              <div className="table_overflow email-campaign-list-table">
                <DataTable
                  columns={columns}
                  noDataComponent={
                    <div className="no-records-found">
                      {searchTextVal !== ""
                        ? t("no_records_search_txt", {
                            recordType: "campaigns",
                          })
                        : t("no_record_txt")}
                      {/* {t("no_records_found_txt", { recordType: "campaigns" })} */}
                    </div>
                  }
                  data={data}
                  customStyles={customStyles}
                  pagination
                  paginationPerPage={25}
                  progressPending={isLoading}
                  paginationRowsPerPageOptions={[25, 50, 75, 100]}
                  paginationComponentOptions={paginationComponentOptions}
                />
              </div>
            </div>
            {isActionLoading && (
              <div className="loading-full-bg">
                <div className="loading-buffer"></div>
              </div>
            )}
            {visibleAlert && (
              <div className="custom-alert-pop paylater-popup">
                <div className="custom-alert-container">
                  <div className="custom-alert-wrap">
                    <div className="custom-alert-header">
                      <h4>{t("alert_txt")}</h4>
                    </div>
                    <div className="custom-alert-body">
                      <p>
                        {t("delete_confirm_common_txt", {
                          recordType: "campaign",
                        })}
                      </p>
                      <div className="alert-buttons">
                        <a
                          onClick={() => deleteCampaign()}
                          className="popup-alert-btn button"
                        >
                          {t("ok_txt")}
                        </a>
                        <a
                          onClick={() => alertPopupclose()}
                          className="popup-alert-btn button"
                        >
                          {t("cancel_txt")}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {showRunStatusPopup && selectedCampaign && (
              <div className="custom-alert-pop paylater-popup">
                <div className="custom-alert-container">
                  <div className="custom-alert-wrap">
                    <div className="custom-alert-header">
                      <h4>{t("confirm_txt")}</h4>
                    </div>
                    <div className="custom-alert-body">
                      <p>
                        {selectedCampaign.runStatus === "run"
                          ? t("confirm_pause_campaign_txt")
                          : t("confirm_resume_campaign_txt")}
                      </p>
                      {selectedCampaign.runStatus === "pause" && (
                        <p className="note-text">
                          <strong>{t("note_txt")}</strong>{" "}
                          {t("campaign_status_update_note_txt")}
                        </p>
                      )}
                      <div className="alert-buttons">
                        <a
                          onClick={() => handleConfirmRunStatusChange()}
                          className="popup-alert-btn button"
                        >
                          {t("ok_txt")}
                        </a>
                        <a
                          onClick={() => {
                            setShowRunStatusPopup(false);
                            setSelectedCampaign(null);
                          }}
                          className="popup-alert-btn button"
                        >
                          {t("cancel_txt")}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
        <Footer />
      </div>
    </section>
  );
};

export default EmailCampaign;
